import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...rest }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          'h-9 w-full rounded-lg border bg-surface px-3 text-sm text-fg',
          'placeholder:text-fg-subtle',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1',
          'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-fg-subtle',
          invalid
            ? 'border-red-400 focus-visible:ring-red-400'
            : 'border-border-strong focus-visible:border-brand-500 focus-visible:ring-brand-400',
          className,
        )}
        {...rest}
      />
    )
  },
)

Input.displayName = 'Input'
